import { render, staticRenderFns } from "./WordpressCache.vue?vue&type=template&id=467a2b13"
import script from "./WordpressCache.vue?vue&type=script&lang=js"
export * from "./WordpressCache.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports